import React, { useState } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { FormSecondStep } from "./secondStepForm";
import { StepButton } from "./stepButton";
import { FormFooter } from "./formFooter";
import moment from "moment";
import * as Yup from "yup";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../title";
import { useSelector } from "react-redux";

// export const MultiStep = () => {
function MultiStep({
  name,
  email,
  phone,
  payRates,
  gender,
  canLive,
  activeStatus,
  handleSubmit,
  trainerAttributes,
  qualifications,
  image,
}) {
  const [step, setStep] = useState(1);
  const { gym } = useSelector((state) => state.gym);
  const submit = (values) => {
    // console.log(values);
    handleSubmit(values);
    console.log(values, "values");
  };

  const [dayTimeState, setDayTimeState] = useState({
    Saturday: [],
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
  });

  const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10-20}$/;

  const formSchema1 = Yup.object().shape({
    name: Yup.string().required("Trainer name is required"),
    phone: Yup.string()
      .max(25, "cannot be > 25 digits")
      .required("Please enter valid phone number"),
    // .matches(phoneRegExp, 'Phone number is not valid'),
    email: Yup.string()
      .email("Please enter valid Username i.e email")
      .max(50, "Email cannot be greater than 50 characters")
      .required("Username is required"),
    // dob: Yup.string().required("Please enter trainer's date of birth"),
    gender: Yup.string().required("Gender is required"),
    canLive: Yup.string().required("Status is required"),
    qualifications: Yup.array().max(8),
    // scheduleDays: Yup.array().min(1, "Please Choose at least 1 day"),
  });

  return (
    <>
      <ModalBody>
        <div className="modal-body-content">
          <div className="add-trainer-popup adding-popup bg-white card-panel">
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title={
                    gym.type == "sportClub" ? "Add Coach"  : gym.type == "complex"
                    ? "Add Instructor"
                    : "Add Instructor"
                  }
                  subtitlestyle="ctf-tx-secondary"
                  subtitle={
                    gym.type == "sportClub"
                      ? "Add Info About Coach"
                      : gym.type == "complex"
                      ? "Add Info Instructor"
                      : "Add Info About Instructor"
                  }
                />
              </div>
              <Formik
                enableReinitialize
                initialValues={{
                  name,
                  email,
                  phone,
                  gender,
                  canLive,
                  activeStatus:activeStatus?activeStatus:"ACTIVE",
                  image,
                  payRates,
                  qualifications,
                  trainerAttributes,
                  dob: moment(new Date()).format("DD/MM/YYYY"),
                  addTrainerAsMember: false,
                }}
                onSubmit={submit}
                validationSchema={formSchema1}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  values,
                  setFieldValue,
                }) => (
                  <Form>
                    {/* {renderStep(step, values, errors, touched, setFieldValue)} */}
                    <FormFirstStep
                      dayTimeState={dayTimeState}
                      setDayTimeState={setDayTimeState}
                      errors={errors}
                      touched={touched}
                      values={values}
                      setFieldValue={setFieldValue}
                      isCreate={true}
                    />
                    <StepButton step={step} />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
}
MultiStep.defaultProps = {
  name: "",
  email: "",
  phone: "",
  subscriptionPlan: "",
  startDate: "",
  endDate: "",
  activeStatus: "",
  qualifications: [],
  canLive: true,
  trainerAttributes: [],
  payRates: [],
  handleSubmit: (values) => {},
  edit: false,
  type: "",
  image: "",
  scheduleDays: [],
};

export default MultiStep;
